// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.strike[data-v-08995772] {\n\ttext-decoration: line-through;\n}\n", ""]);
// Exports
module.exports = exports;
